import { Component, EventEmitter, Input, Output } from '@angular/core'
import { SharedModule } from '@shared/shared.module'
import { ScopeUiDropdownComponent } from '@shared/components/ui-components/scope-ui-dropdown/scope-ui-dropdown.component'

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE_SET_SIZE = 10

@Component({
  standalone: true,
  selector: 'scope-ui-paginator',
  templateUrl: './scope-ui-paginator.component.html',
  imports: [SharedModule, ScopeUiDropdownComponent],
  styleUrls: ['./scope-ui-paginator.component.scss'],
})
export class ScopeUiPaginatorComponent {
  private _currentPage = 0
  @Input() set currentPage(value: number) {
    if (value !== undefined && value !== this._currentPage) {
      this._currentPage = value
      this.updateVisiblePages()
    }
  }
  get currentPage(): number {
    return this._currentPage
  }

  private _pageSize = DEFAULT_PAGE_SIZE
  @Input() set pageSize(value: number) {
    if (value !== undefined && value !== this._pageSize) {
      this._pageSize = value
      if (this.total !== undefined) {
        this.setPageSets()
      }
    }
  }
  get pageSize(): number {
    return this._pageSize
  }

  @Input() pageSetSize = DEFAULT_PAGE_SET_SIZE
  @Input() sizeOptions?: any[]
  @Input() set totalCount(value: number) {
    if (value !== undefined) {
      this.total = value
      this.setPageSets()
    }
  }
  @Output() changePage = new EventEmitter<any>()

  total: number
  pages: number[] = []
  visiblePages: { first: number; last: number }
  pageSets: { first: number; last: number }[] = []

  setPageSets() {
    const totalPages = Math.ceil(this.total / this.pageSize)
    this.pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    this.pageSets = []
    for (let i = 1; i <= this.pages.length; i += this.pageSetSize) {
      this.pageSets.push({ first: i, last: Math.min(i + this.pageSetSize - 1, this.pages.length) })
    }

    this.updateVisiblePages()
  }

  updateVisiblePages() {
    if (!this.pageSets?.length) {
      return
    }
    const pageNumber = this.currentPage + 1
    const targetSet = this.pageSets.find((set) => pageNumber >= set.first && pageNumber <= set.last)

    if (targetSet) {
      this.visiblePages = targetSet
    } else if (this.pageSets.length) {
      this.visiblePages = this.pageSets[0]
    }
  }

  onChangePage(page: number) {
    if (page < 0 || page >= this.pages.length) {
      return
    }
    this.changePage.emit({ pageIndex: page, pageSize: this.pageSize })
  }

  onChangeSize(size: number) {
    this.pageSize = size
    this.currentPage = 0
    this.changePage.emit({ pageIndex: 0, pageSize: this.pageSize })
  }

  displayFn = (option: { first: number; last: number }) => {
    return `${option.first}${option.last != option.first ? ' to ' + option.last : ''}`
  }
}
